<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc">
<header>
<h2 class="h2f"><a id="page_vii"></a>Contents</h2>
</header>
<p class="toc"><a href="#/xhtml/fm03">Acknowledgements</a></p>
<p class="toc"><a href="#/xhtml/fm04">Maps</a></p>
<p class="toc"><a href="#/xhtml/fm05">Preface</a></p>
<p class="toc"><a href="#/xhtml/fm06">Introduction</a></p>
<p class="tocp"><a href="#/xhtml/part01">Part One<br/>The Word Must Be Spread</a></p>
<p class="toc"><a href="#/xhtml/chapter01"><span class="tc">  1</span> The Lauras</a></p>
<p class="toc"><a href="#/xhtml/chapter02"><span class="tc">  2</span> The Deserts of the North</a></p>
<p class="toc"><span href="#/xhtml/chapter03" title="Link target outside of Sample"><span class="tc">  3</span> The Colours of Martyrdom</span></p>
<p class="toc"><span href="#/xhtml/chapter04" title="Link target outside of Sample"><span class="tc">  4</span> The Land of Promise of the Saints</span></p>
<p class="tocp"><span href="#/xhtml/part02" title="Link target outside of Sample">Part Two<br/>The Rock of the Saint – Eileach an Naoimh</span></p>
<p class="toc"><span href="#/xhtml/chapter05" title="Link target outside of Sample"><span class="tc">  5</span> Setting off for the Edge of the World</span></p>
<p class="toc"><span href="#/xhtml/chapter06" title="Link target outside of Sample"><span class="tc">  6</span> On Brendan’s Isle</span></p>
<p class="toc"><span href="#/xhtml/chapter07" title="Link target outside of Sample"><span class="tc">  7</span> The Place of Penance</span></p>
<p class="tocp"><span href="#/xhtml/part03" title="Link target outside of Sample">Part Three<br/>The Great Garden – Lismore</span></p>
<p class="toc"><span href="#/xhtml/chapter08" title="Link target outside of Sample"><span class="tc">  8</span> On the Feast of St Moluag</span></p>
<p class="toc"><span href="#/xhtml/chapter09" title="Link target outside of Sample"><span class="tc">  9</span> Walking to the Cathedral</span></p>
<p class="toc"><span href="#/xhtml/chapter10" title="Link target outside of Sample"><span class="tc">10</span> The Apostle of the Picts</span></p>
<p class="toc"><span href="#/xhtml/chapter11" title="Link target outside of Sample"><span class="tc">11</span> Waiting for the Ferry</span></p>
<p class="tocp"><a id="page_viii"></a><span href="#/xhtml/part04" title="Link target outside of Sample">Part Four<br/>The Isle of the Yew Tree – Iona</span></p>
<p class="toc"><span href="#/xhtml/chapter12" title="Link target outside of Sample"><span class="tc">12</span> Founders</span></p>
<p class="toc"><span href="#/xhtml/chapter13" title="Link target outside of Sample"><span class="tc">13</span> Beyond the Corncrake Meadow</span></p>
<p class="toc"><span href="#/xhtml/chapter14" title="Link target outside of Sample"><span class="tc">14</span> The Graveyard of the Kings</span></p>
<p class="toc"><span href="#/xhtml/chapter15" title="Link target outside of Sample"><span class="tc">15</span> The Night Before the Morning</span></p>
<p class="toc"><span href="#/xhtml/chapter16" title="Link target outside of Sample"><span class="tc">16</span> The Scribes and the Scribbler</span></p>
<p class="tocp"><span href="#/xhtml/part05" title="Link target outside of Sample">Part Five<br/>Into Eden – Applecross</span></p>
<p class="toc"><span href="#/xhtml/chapter17" title="Link target outside of Sample"><span class="tc">17</span> The Red Priest</span></p>
<p class="toc"><span href="#/xhtml/chapter18" title="Link target outside of Sample"><span class="tc">18</span> Beyond the Pass of the Cattle</span></p>
<p class="toc"><span href="#/xhtml/chapter19" title="Link target outside of Sample"><span class="tc">19</span> The Language of Miracles</span></p>
<p class="toc"><span href="#/xhtml/chapter20" title="Link target outside of Sample"><span class="tc">20</span> The Sanctuary</span></p>
<p class="toc"><span href="#/xhtml/chapter21" title="Link target outside of Sample"><span class="tc">21</span> The End of the Rainbow</span></p>
<p class="toca1"><span href="#/xhtml/bm01" title="Link target outside of Sample">Epilogue The Blood of Blathmac</span></p>
<p class="toca1"><span href="#/xhtml/bm02" title="Link target outside of Sample">Further Reading</span></p>
<p class="toca"><span href="#/xhtml/bm03" title="Link target outside of Sample">Index</span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?2952e7d3